/**
 * App Store / Play Store URLs for "Get the app" CTAs.
 *
 * Centralised so the PaywallSheet, /get redirect page, and any
 * future Smart App Banner / landing-page integration all reference
 * the same canonical links.
 *
 * Both are placeholders (`#`) until the apps publish in their
 * respective stores. Replace `#` with the real listing URL when:
 *   - iOS: `https://apps.apple.com/app/id<digits>?mt=8` (numeric
 *     app id comes from App Store Connect after the listing is
 *     live).
 *   - Android: `https://play.google.com/store/apps/details?id=app.wydm.client`
 *     (the package id comes from src/app/app.json → android.package).
 *
 * `#` is deliberate vs an empty string — empty `href` would make
 * the badges look unclickable; `#` keeps them interactive without
 * navigating away from the page. The store badges already use
 * `target="_blank"` semantics implicitly via the StoreBadges
 * component, so once the real URLs land they'll open in a new tab.
 */

export const APP_STORE_URL = '#';
export const PLAY_STORE_URL = '#';

// Canonical "get the app" smart-redirect URL on our own domain.
// /get sniffs the user-agent and 302s to the right store. Used as
// the QR-code payload on desktop so a phone scan lands on the right
// store without the desktop user having to pick a platform.
export const GET_THE_APP_URL = 'https://wydm.app/get';

// Subscription-management URLs — point at each store's "your
// subscriptions" page. Unlike the listing URLs above these are
// REAL today: both Apple and Google host stable manage-subs URLs
// that open the user's Apple ID / Google account subscriptions
// list. Used by the Settings plan badge's "Manage in <store>"
// link so a premium user can cancel / change tier without
// hunting through OS settings.
export const APP_STORE_MANAGE_URL  = 'https://apps.apple.com/account/subscriptions';
export const PLAY_STORE_MANAGE_URL = 'https://play.google.com/store/account/subscriptions';
